import React from 'react'

function previewDocument(bodyHtml) {
  return `<!doctype html><html lang="ko"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><base target="_blank"><style>html,body{margin:0;background:#fff;color:#25211d;font-family:Pretendard,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif}body{padding:34px 38px;font-size:15px;line-height:1.8;overflow-wrap:anywhere}*{box-sizing:border-box}img,video{max-width:100%;height:auto}table{max-width:100%;border-collapse:collapse;display:block;overflow:auto}th,td{border:1px solid #e8e1d8;padding:8px 10px}pre{max-width:100%;overflow:auto;padding:14px;background:#f7f4ef;border-radius:10px}a{color:#d95816}iframe,object,embed,form{display:none!important}@media(max-width:640px){body{padding:22px 18px;font-size:14px}}</style></head><body>${bodyHtml || '<p>등록된 본문이 없습니다.</p>'}</body></html>`
}

export default function AdminHtmlPreview({ bodyHtml, title = '본문 미리보기', description = '관리자 레이아웃과 분리된 안전한 미리보기 영역입니다.' }) {
  return <div style={{ overflow:'hidden', border:'1px solid var(--line)', borderRadius:12, background:'#fff' }}>
    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:12, padding:'13px 17px', borderBottom:'1px solid var(--line)', background:'var(--surface-2)', flexWrap:'wrap' }}>
      <strong style={{ fontSize:13 }}>{title}</strong>
      <span style={{ fontSize:11, color:'var(--muted)' }}>{description}</span>
    </div>
    <iframe
      title={title}
      sandbox=""
      referrerPolicy="no-referrer"
      srcDoc={previewDocument(bodyHtml)}
      style={{ display:'block', width:'100%', height:'min(760px,72vh)', border:0, background:'#fff' }}
    />
  </div>
}
